var _g, _g2, _g3, _g4, _circle, _g5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClientsDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 33,
    viewBox: "0 0 38 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 4.27732,
    cy: 4.27732,
    r: 4.27732,
    transform: "matrix(-1 0 0 1 30.1865 8.14331)",
    fill: "url(#paint0_linear_5443_3468)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.27732,
    cy: 4.27732,
    r: 4.10766,
    transform: "matrix(-1 0 0 1 30.1865 8.14331)",
    stroke: "url(#paint1_linear_5443_3468)",
    strokeOpacity: 0.7,
    strokeWidth: 0.339306,
    shapeRendering: "crispEdges"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 4.27732,
    cy: 4.27732,
    r: 4.27732,
    transform: "matrix(-1 0 0 1 15.833 8.14331)",
    fill: "url(#paint2_linear_5443_3468)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.27732,
    cy: 4.27732,
    r: 4.10766,
    transform: "matrix(-1 0 0 1 15.833 8.14331)",
    stroke: "url(#paint3_linear_5443_3468)",
    strokeOpacity: 0.7,
    strokeWidth: 0.339306,
    shapeRendering: "crispEdges"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.4241 21.9745C18.4241 21.0545 19.0024 20.2339 19.8688 19.9244C23.775 18.5294 28.0437 18.5294 31.9499 19.9244C32.8163 20.2339 33.3947 21.0545 33.3947 21.9746V23.481C33.3947 24.6981 32.3167 25.6331 31.1118 25.4609L29.7278 25.2632C27.195 24.9014 24.6237 24.9014 22.091 25.2632L20.7069 25.4609C19.502 25.6331 18.4241 24.6981 18.4241 23.481V21.9745Z",
    fill: "url(#paint4_linear_5443_3468)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5937 21.9745C18.5937 21.1262 19.127 20.3695 19.9259 20.0842C23.7952 18.7023 28.0236 18.7023 31.8929 20.0842C32.6917 20.3695 33.225 21.1262 33.225 21.9746V23.481C33.225 24.5949 32.2385 25.4505 31.1358 25.293L29.7517 25.0953C27.2031 24.7312 24.6156 24.7312 22.067 25.0953L20.6829 25.293C19.5803 25.4505 18.5937 24.5949 18.5937 23.481V21.9745Z",
    stroke: "url(#paint5_linear_5443_3468)",
    strokeOpacity: 0.7,
    strokeWidth: 0.339306,
    shapeRendering: "crispEdges"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.07056 21.9745C4.07056 21.0545 4.64891 20.2339 5.51532 19.9244C9.42152 18.5294 13.6902 18.5294 17.5964 19.9244C18.4628 20.2339 19.0412 21.0545 19.0412 21.9746V23.481C19.0412 24.6981 17.9632 25.6331 16.7583 25.4609L15.3742 25.2632C12.8415 24.9014 10.2702 24.9014 7.73748 25.2632L6.3534 25.4609C5.14853 25.6331 4.07056 24.6981 4.07056 23.481V21.9745Z",
    fill: "url(#paint6_linear_5443_3468)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.24021 21.9745C4.24021 21.1262 4.77349 20.3695 5.57238 20.0842C9.44169 18.7023 13.67 18.7023 17.5393 20.0842C18.3382 20.3695 18.8715 21.1262 18.8715 21.9746V23.481C18.8715 24.5949 17.885 25.4505 16.7823 25.293L15.3982 25.0953C12.8496 24.7312 10.2621 24.7312 7.71349 25.0953L6.32941 25.293C5.22675 25.4505 4.24021 24.5949 4.24021 23.481V21.9745Z",
    stroke: "url(#paint7_linear_5443_3468)",
    strokeOpacity: 0.7,
    strokeWidth: 0.339306,
    shapeRendering: "crispEdges"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.4289,
    cy: 5.4289,
    r: 5.4289,
    transform: "matrix(-1 0 0 1 24.429 5.42871)",
    fill: "#0088CC"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.49951 22.984C9.49951 21.8163 10.2336 20.7747 11.3332 20.382C16.2911 18.6113 21.7091 18.6113 26.6669 20.382C27.7666 20.7747 28.5007 21.8163 28.5007 22.984V25.517C28.5007 26.7341 27.4227 27.669 26.2178 27.4969L22.8185 27.0112C20.2857 26.6494 17.7144 26.6494 15.1817 27.0112L11.7824 27.4969C10.5775 27.669 9.49951 26.7341 9.49951 25.517V22.984Z",
    fill: "url(#paint8_linear_5443_3468)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.66916 22.984C9.66916 21.888 10.3582 20.9104 11.3903 20.5417C16.3113 18.7842 21.6889 18.7842 26.6099 20.5417C27.642 20.9104 28.331 21.888 28.331 22.984V25.517C28.331 26.6308 27.3445 27.4864 26.2418 27.3289L22.8425 26.8433C20.2938 26.4792 17.7064 26.4792 15.1577 26.8433L11.7584 27.3289C10.6557 27.4864 9.66916 26.6308 9.66916 25.517V22.984Z",
    stroke: "url(#paint9_linear_5443_3468)",
    strokeOpacity: 0.7,
    strokeWidth: 0.339306,
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bdi_5443_3468",
    x: 17.6318,
    y: 4.14331,
    width: 16.5547,
    height: 16.5547,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_5443_3468"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.231373 0 0 0 0 0.407843 0 0 0 0 1 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_5443_3468",
    result: "effect2_dropShadow_5443_3468"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_5443_3468",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.231373 0 0 0 0 0.407843 0 0 0 0 1 0 0 0 0.38 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow_5443_3468"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_bdi_5443_3468",
    x: 3.27832,
    y: 4.14331,
    width: 16.5547,
    height: 16.5547,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_5443_3468"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.231373 0 0 0 0 0.407843 0 0 0 0 1 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_5443_3468",
    result: "effect2_dropShadow_5443_3468"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_5443_3468",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.231373 0 0 0 0 0.407843 0 0 0 0 1 0 0 0 0.38 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow_5443_3468"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_bdi_5443_3468",
    x: 14.4241,
    y: 14.8782,
    width: 22.9707,
    height: 14.6033,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_5443_3468"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.231373 0 0 0 0 0.407843 0 0 0 0 1 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_5443_3468",
    result: "effect2_dropShadow_5443_3468"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_5443_3468",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.231373 0 0 0 0 0.407843 0 0 0 0 1 0 0 0 0.38 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow_5443_3468"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_bdi_5443_3468",
    x: 0.0705566,
    y: 14.8782,
    width: 22.9707,
    height: 14.6033,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_5443_3468"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.231373 0 0 0 0 0.407843 0 0 0 0 1 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_5443_3468",
    result: "effect2_dropShadow_5443_3468"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_5443_3468",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.231373 0 0 0 0 0.407843 0 0 0 0 1 0 0 0 0.38 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow_5443_3468"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_bdi_5443_3468",
    x: 5.49951,
    y: 15.054,
    width: 27.0012,
    height: 16.4634,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_5443_3468"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.231373 0 0 0 0 0.407843 0 0 0 0 1 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_5443_3468",
    result: "effect2_dropShadow_5443_3468"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_5443_3468",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.231373 0 0 0 0 0.407843 0 0 0 0 1 0 0 0 0.38 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow_5443_3468"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5443_3468",
    x1: -2.78026,
    y1: -3.42185,
    x2: 13.0458,
    y2: 10.6933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "white",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.04
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5443_3468",
    x1: 0.213866,
    y1: 1.28319,
    x2: 7.69917,
    y2: 7.69917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.44
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5443_3468",
    x1: -2.78026,
    y1: -3.42185,
    x2: 13.0458,
    y2: 10.6933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "white",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.04
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5443_3468",
    x1: 0.213866,
    y1: 1.28319,
    x2: 7.69917,
    y2: 7.69917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.44
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5443_3468",
    x1: 13.5586,
    y1: 14.5591,
    x2: 26.7425,
    y2: 36.5085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "white",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.04
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5443_3468",
    x1: 18.7983,
    y1: 18.9701,
    x2: 25.1813,
    y2: 29.1828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.44
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_5443_3468",
    x1: -0.794891,
    y1: 14.5591,
    x2: 12.389,
    y2: 36.5085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "white",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.04
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_5443_3468",
    x1: 4.44482,
    y1: 18.9701,
    x2: 10.8278,
    y2: 29.1828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.44
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_5443_3468",
    x1: 3.32414,
    y1: 13.5721,
    x2: 20.0575,
    y2: 41.431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "white",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.04
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_5443_3468",
    x1: 9.97454,
    y1: 19.1707,
    x2: 18.076,
    y2: 32.1329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.44
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientsDark);
export default __webpack_public_path__ + "static/media/clients-dark.beb81c195f80a4c8d4e9bc5fabdea665.svg";
export { ForwardRef as ReactComponent };